// Below this viewport width the navbar collapses into the mobile Offcanvas menu.
export const MOBILE_BREAKING_POINT = 1024

// Rendered in place of a figure a record never carried, so an absent value never reads as a zero.
export const NO_VALUE = '—'
